import React, { useEffect, useRef } from 'react'

export const useMounted = () => {
  const ref = useRef(true)

  useEffect(() => {
    return () => {
      ref.current = false
    }
  }, [])

  return ref
}
